import { Image as MantineImage, ImageProps as MantineImageProps } from "@mantine/core";
import { forwardRef } from "react";

export type ImageProps = MantineImageProps & {
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
};

export const Image = forwardRef<HTMLImageElement, ImageProps>((props: ImageProps, ref) => {
  return <MantineImage {...props} ref={ref} />;
});
